import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Thumbnail from '@base/Thumbnail/Thumbnail';
import LinearProgressBar from '@base/LinearProgressBar/LinearProgressBar';
import Link from '@base/Link/Link';
import { pluralize } from '@utils/textHelper';
import {
  getLinkPath as getCourseHref,
  getLink as getCourseAsPath
} from '@models/Course';
import segmentStorage from '@events/segmentStorage';
import { breakpoints, Spacings } from '@styles/index';
import { StyledTag as ItemsTag, Container } from '../CourseCard';
import FreeCourseCardDetails from './FreeCourseCardDetails';

const CardContainer = styled(Container)`
  display: flex;
  flex: 1;
  overflow: hidden;
  flex-direction: ${({ orientation }) =>
    orientation === 'horizontal' ? 'row' : 'column'};
  @media only screen and (max-width: ${breakpoints.mobile}) {
    flex: auto;
  }
`;

const StyledThumbnail = styled(Thumbnail)`
  border-top-left-radius: ${Spacings.SPACING_2B};
  border-top-right-radius: ${({ orientation }) =>
    orientation === 'vertical' && Spacings.SPACING_2B};
  height: ${({ orientation }) => orientation === 'horizontal' && '152px'};
`;

const FreeCourseCard = ({
  course,
  gridColumn,
  orientation,
  className,
  dataAnalytics,
  label
}) => {
  if (!course) return null;
  const handleAnalytics = () => {
    segmentStorage.setItem('lpss', label);
  };

  return (
    <CardContainer
      className={className}
      gridColumn={gridColumn}
      orientation={orientation}
    >
      <Link
        href={getCourseHref(course)}
        as={getCourseAsPath(course)}
        onClick={handleAnalytics}
      >
        <StyledThumbnail
          imgUrl={course.thumbnail}
          orientation={orientation}
          dataAnalytics={`${dataAnalytics}-courseEnroll`}
        >
          {course.itemCount ? (
            <ItemsTag type="filled">
              {pluralize(course.itemCount, 'lesson')}
            </ItemsTag>
          ) : null}
        </StyledThumbnail>
        {orientation === 'vertical' && course.progress && (
          <LinearProgressBar
            value={course.progress.percentage || 0}
            width="100%"
            borderRadius="0px"
            backgroundColor="var(--color-base-1)"
          />
        )}
      </Link>
      <FreeCourseCardDetails
        course={course}
        handleAnalytics={handleAnalytics}
      />
    </CardContainer>
  );
};

export default FreeCourseCard;

FreeCourseCard.propTypes = {
  course: PropTypes.objectOf(PropTypes.any).isRequired,
  gridColumn: PropTypes.string,
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  className: PropTypes.string,
  dataAnalytics: PropTypes.string,
  label: PropTypes.string
};

FreeCourseCard.defaultProps = {
  gridColumn: 'span 6',
  orientation: 'vertical',
  className: '',
  dataAnalytics: '',
  label: ''
};
